import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CommitPage from './CommitPage';
export default function PullRequestPage(props) {
    return _jsx(CommitPage, { ...props, pullRequestId: Number(props.match.params.id) });
}
